import React from 'react'
import { strings } from '../../../localization/strings'
import { Typography } from '@material-ui/core/index'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Button from '@material-ui/core/Button'
import TimeInput from 'material-ui-time-picker'
import moment from 'moment'

class Component extends React.Component {
    initialState = {
        error: {},
        editing: false,
        startTime: null,
        endTime: null,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
    }

    state = {
        ...this.initialState,
        ...this.props.initialValue,
    }

    submitOkData = () => {
        var {
            startTime,
            endTime,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday,
        } = { ...this.state }
        return {
            startTime,
            endTime,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday,
        }
    }

    render() {
        const { errors } = this.props
        const { editing } = this.state
        const {
            startTime,
            endTime,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday,
        } = this.state

        const toUpFirst = (x) => x.charAt(0).toUpperCase() + x.slice(1)
        const formatReq = (string) => (
            <div>
                {string}
                <span style={{ color: 'red' }}> *</span>
            </div>
        )
        var days = ''
        ;[
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
            'sunday',
        ].forEach((x) => {
            if (this.state[x]) {
                if (days.length > 0) days += ', '
                days += strings[x]
            }
        })
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: '50px 0px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'baseline',
                        margin: '20px auto 10px auto',
                    }}
                >
                    {strings.pickupSchedule_title}
                    {/*<Button color="primary" size="small" onClick={this.onEditClick} disabled={!canOpen}>*/}
                    {/*{strings.registrationAddressUpdateButton}*/}
                    {/*</Button>*/}
                </div>

                {!editing ? (
                    !days || !startTime || !endTime ? (
                        <div
                            style={{
                                color: 'red',
                                fontSize: '80%',
                                margin: 'auto',
                            }}
                        >
                            Faltan completar datos obligatorios
                        </div>
                    ) : (
                        <div
                            style={{
                                display: 'flex',
                                fontSize: '80%',
                                flexDirection: 'column',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                marginTop: 10,
                            }}
                        >
                            {strings.pickupSchedule_theDays} {days}
                            {' ' + strings.pickupSchedule_startTime}:{' '}
                            {moment(startTime).format('HH:mm')}
                            {' ' + strings.pickupSchedule_endTime}:{' '}
                            {moment(endTime).format('HH:mm')}
                        </div>
                    )
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: 10,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                            }}
                        >
                            <Typography
                                style={{ minWidth: 75 }}
                                variant="body2"
                                color={!errors.startTime ? 'inherit' : 'error'}
                            >
                                {toUpFirst(strings.pickupSchedule_startTime)}
                            </Typography>
                            <TimeInput
                                mode="24h"
                                value={startTime}
                                disabled={!editing}
                                cancelLabel={strings.dialogCancelLabel}
                                okLabel={strings.dialogOkLabel}
                                onChange={(x) => {
                                    if (moment(endTime) < moment(x)) {
                                        this.setState({ startTime: endTime })
                                        window.showDialog({
                                            message:
                                                'El horario inicial no puede ser mayor al final',
                                        })
                                    } else {
                                        this.setState({ startTime: x })
                                    }
                                }}
                            />
                            {formatReq('')}
                            <Typography
                                style={{ minWidth: 75, marginLeft: 10 }}
                                variant="body2"
                                color={!errors.endTime ? 'inherit' : 'error'}
                            >
                                {toUpFirst(strings.pickupSchedule_endTime)}
                            </Typography>
                            <TimeInput
                                mode="24h"
                                value={endTime}
                                disabled={!editing}
                                cancelLabel={strings.dialogCancelLabel}
                                okLabel={strings.dialogOkLabel}
                                onChange={(x) => {
                                    if (moment(startTime) > moment(x)) {
                                        this.setState({ endTime: startTime })
                                        window.showDialog({
                                            message:
                                                'El horario inicial no puede ser mayor al final',
                                        })
                                    } else {
                                        this.setState({ endTime: x })
                                    }
                                }}
                            />
                            {formatReq('')}
                        </div>
                        <div
                            style={{
                                fontSize: '80%',
                                marginTop: 20,
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                marginBottom: 20,
                            }}
                        >
                            {formatReq(
                                'Selecciona los dias de despacho (al menos uno)'
                            )}
                        </div>
                        <FormControl
                            disabled={!editing}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                marginTop: 0,
                            }}
                        >
                            <FormControlLabel
                                style={{ margin: 0 }}
                                value="top"
                                labelPlacement="top"
                                control={<Checkbox color="primary" />}
                                label={toUpFirst(strings.monday)}
                                checked={monday}
                                onChange={(x) =>
                                    this.setState({ monday: x.target.checked })
                                }
                            />
                            <FormControlLabel
                                style={{ margin: 0 }}
                                value="top"
                                labelPlacement="top"
                                control={<Checkbox color="primary" />}
                                label={toUpFirst(strings.tuesday)}
                                checked={tuesday}
                                onChange={(x) =>
                                    this.setState({ tuesday: x.target.checked })
                                }
                            />
                            <FormControlLabel
                                style={{ margin: 0 }}
                                value="top"
                                labelPlacement="top"
                                control={<Checkbox color="primary" />}
                                label={toUpFirst(strings.wednesday)}
                                checked={wednesday}
                                onChange={(x) =>
                                    this.setState({
                                        wednesday: x.target.checked,
                                    })
                                }
                            />
                            <FormControlLabel
                                style={{ margin: 0 }}
                                value="top"
                                labelPlacement="top"
                                control={<Checkbox color="primary" />}
                                label={toUpFirst(strings.thursday)}
                                checked={thursday}
                                onChange={(x) =>
                                    this.setState({
                                        thursday: x.target.checked,
                                    })
                                }
                            />
                            <FormControlLabel
                                style={{ margin: 0 }}
                                value="top"
                                labelPlacement="top"
                                control={<Checkbox color="primary" />}
                                label={toUpFirst(strings.friday)}
                                checked={friday}
                                onChange={(x) =>
                                    this.setState({ friday: x.target.checked })
                                }
                            />
                            <FormControlLabel
                                style={{ margin: 0 }}
                                value="top"
                                labelPlacement="top"
                                control={<Checkbox color="primary" />}
                                label={toUpFirst(strings.saturday)}
                                checked={saturday}
                                onChange={(x) =>
                                    this.setState({
                                        saturday: x.target.checked,
                                    })
                                }
                            />
                            <FormControlLabel
                                style={{ margin: 0 }}
                                value="top"
                                labelPlacement="top"
                                control={<Checkbox color="primary" />}
                                label={toUpFirst(strings.sunday)}
                                checked={sunday}
                                onChange={(x) =>
                                    this.setState({ sunday: x.target.checked })
                                }
                            />
                        </FormControl>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                marginTop: 20,
                            }}
                        >
                            <div style={{ flexGrow: 1 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitCancel}
                            >
                                {strings.dialogCancelLabel}
                            </Button>
                            <div style={{ width: 100 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitOk}
                            >
                                {strings.dialogOkLabel}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    submitOk = () => {
        var data = this.submitOkData()
        if (!data) return
        this.props.onChange(data)
        this.props.toggleOpen(false)
        this.clearState(data)
    }

    submitCancel = () => {
        this.props.toggleOpen(false)
        this.clearState(this.props.initialValue)
    }

    onEditClick = () => {
        this.setState({ editing: true })
        this.props.toggleOpen(true)
    }

    clearState = (data) => {
        this.setState({ ...this.initialState, ...data })
    }

    componentDidMount() {}
}

export default Component
